// angular
//     .module("HeroPRO")
//     .filter("zeroDashCurrency",["$filter","$locale", zeroDashCurrency]);

import angular from 'angular';

/* @ngInject */
export default function zeroDashCurrency($filter, $locale) {
    const currencyFilter = $filter('currency');
    const formats = $locale.NUMBER_FORMATS;
    return function zeroDashCurrencyFilter(amount, currencySymbol) {
        if (angular.isUndefined(currencySymbol)) { currencySymbol = formats.CURRENCY_SYM; }
        if (amount === 0) {
            return '-';
        }
        return currencyFilter(amount, currencySymbol);
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/filters/zeroDashCurrency.filter.js